import axios from 'axios'
import { getStroage } from 'utils'

const apiUrl = process.env.REACT_APP_SERVER
const apiReportUrl = process.env.REACT_APP_REPORT
const apiStreamerReportUrl = process.env.REACT_APP_STREAMER_REPORT

// 接口环境
export const requst = axios.create({
    baseURL: apiUrl, // 源地址
})

// 取消请求函数
export let cancelFn = () => { }

// 请求拦截器
requst.interceptors.request.use(config => {
    const result = config.url.match(/^\/report/)
    const result2 = config.url.match('/webroot/decision/view/report')
    // const result3 = config.url.match('/dashboardStreamerTotal')
    // const result4 = config.url.match('/report/listAll')
    const result5 = config.url.match('http://47.239.23.211:8080/auth/login')
    const result6 = config.url.match('/flag-business/megaShare')
    const result7 = config.url.match('/loginByTicket')
    const result8 = config.url.match('/auth/logoutByTicket')
    const result9 = config.url.match('http://8.222.251.40:8000/auth/login')
    if (result7 || result8 || result9) {
        return config
    }

    if (result) config.baseURL = apiReportUrl

    // if (result) config.baseURL = 'http://192.168.0.101:8889'
    if (result2) config.baseURL = apiStreamerReportUrl
    // if (result3) config.baseURL = 'http://192.168.0.101:8888'
    // if (result4) config.baseURL = 'http://192.168.0.101:8888'
    // flag 2.0
    if (result6){
        return config
    }
    config.headers['Authorization'] = 'Bearer ' + getStroage('token') // 携带 token
    config.headers['Accept-Language'] = getStroage('language') === 'en' ? 'en-US' : 'zh-CN' // 携带当前语言
    // flag 2.0
    if (result5) config.headers['Authorization'] = ''
    return config

})

// 响应拦截器
requst.interceptors.response.use(
    res => {
        // 注册取消请求函数
        res.cancelToken = new axios.CancelToken(c => {
            cancelFn = c
        })
        // 2xx 范围内的状态码
        if (res.status === 200) {
            if (res.data.code) {
                // 自定义状态码
                switch (res.data.code) {
                    case 200:
                        return res
                    default:
                        return Promise.reject(res)
                }
            } else {
                return res
            }
        } else {
            return Promise.reject(res)
        }
    },
    error => {
        // 超出 2xx 范围状态码
        if (error.response.status === 401) {
            return Promise.reject({ data: { code: 401, text: "重复登陆" } })
        } else {
            return Promise.reject({ data: { code: 100 } })
        }

    }
)
